import ashby from './ashby';
import greenhouse from './greenhouse';

export const providers = {
  ashby,
  greenhouse,
};

export const getProvider = (id) => providers[id];

export const getAllProviders = () => Object.values(providers);

export default providers;
